import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C2E0FF",
      d: "M25 3.75c0 .89-.703 1.64-1.828 2.25-1.36.797-3.375 1.313-5.719 1.453a1.7 1.7 0 0 1-.515-.234C15.063 6.469 12.625 6 10 6c-.422 0-.797.047-1.172.047 0 0-.047 0-.047-.047C7.656 5.39 7 4.64 7 3.75 7 1.688 10.984 0 16 0c4.969 0 9 1.688 9 3.75m-4.5 9.328c.844-.234 1.688-.469 2.438-.75A10 10 0 0 0 25 11.11v1.641c0 1.406-1.828 2.625-4.5 3.281zm0-1.828c0-.984-.516-1.828-1.172-2.484 1.36-.188 2.578-.516 3.61-.938A10 10 0 0 0 25 6.61V8.25c0 .844-.703 1.64-1.828 2.25-.094.047-.14.094-.235.14-.703.376-1.546.657-2.437.891z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F85FA",
      d: "M19 11.25c0 .844-.703 1.64-1.828 2.25-1.64.938-4.266 1.5-7.172 1.5-2.812 0-5.297-.516-6.984-1.36-.094-.046-.141-.093-.235-.14C1.656 12.89 1 12.094 1 11.25 1 9.188 4.984 7.5 10 7.5c4.969 0 9 1.688 9 3.75m-9 5.25c2.625 0 5.063-.422 6.938-1.172A10 10 0 0 0 19 14.11v1.641c0 .844-.703 1.64-1.828 2.25-.094.047-.14.094-.235.14-1.687.844-4.171 1.36-6.937 1.36-2.953 0-5.578-.562-7.219-1.5C1.656 17.39 1 16.594 1 15.75v-1.64c.563.468 1.266.89 2.016 1.218C4.89 16.078 7.328 16.5 10 16.5m9 2.11v1.64c0 2.11-4.031 3.75-9 3.75-5.016 0-9-1.64-9-3.75v-1.64c.563.468 1.266.89 2.016 1.218C4.89 20.578 7.328 21 10 21c2.625 0 5.063-.422 6.938-1.172A10 10 0 0 0 19 18.61"
    }, null, -1)
  ]))]))
}
export default { render: render }